import MsDyn365, { IActionContext } from '@msdyn365-commerce/core';
import { ISaveForLaterCollection } from '../../../modules/dobbies-cart/dobbies-cart';
export const setLocalStorage = (key: string, value: string) => {
    if (MsDyn365.isBrowser) {
        if (localStorage) {
            localStorage.setItem(key, value);
        }
    }
};

export const getLocalStorage = (key: string): string | undefined | null => {
    if (MsDyn365.isBrowser) {
        if (localStorage) {
            return localStorage.getItem(key);
        }
    }
    return undefined;
};

export const getAllSavedForLaterProducts = (): ISaveForLaterCollection => {
    const existingSaveForLaterObjsString = getLocalStorage('save_for_later_objs');
    if (existingSaveForLaterObjsString) {
        try {
            const existingSaveForLaterObjs: ISaveForLaterCollection = JSON.parse(existingSaveForLaterObjsString);
            return existingSaveForLaterObjs;
        } catch (e) {
            console.error('Error parsing save for later', e);
        }
    }
    return { saveForLaterProducts: [] };
};

export const removeProductFromSaveForLater = (productId: number) => {
    const existingSaveForLaterObjsString = getLocalStorage('save_for_later_objs');
    if (existingSaveForLaterObjsString) {
        try {
            const existingSaveForLaterObjs: ISaveForLaterCollection = JSON.parse(existingSaveForLaterObjsString);
            if (Array.isArray(existingSaveForLaterObjs.saveForLaterProducts)) {
                existingSaveForLaterObjs.saveForLaterProducts = existingSaveForLaterObjs.saveForLaterProducts.filter(
                    sflp => sflp.productId !== productId
                );
            }
            setLocalStorage('save_for_later_objs', JSON.stringify(existingSaveForLaterObjs));
        } catch (e) {
            console.error('Error parsing save for later', e);
        }
    }
};

export const addProductToSaveForLater = async (productId: number, quantity: number, ctx: IActionContext, fulfillmentStoreId?: string) => {
    const existingSaveForLaterObjsString = getLocalStorage('save_for_later_objs');
    if (existingSaveForLaterObjsString) {
        try {
            const existingSaveForLaterObjs: ISaveForLaterCollection = JSON.parse(existingSaveForLaterObjsString);
            if (Array.isArray(existingSaveForLaterObjs.saveForLaterProducts)) {
                existingSaveForLaterObjs.saveForLaterProducts.push({
                    productId: productId,
                    quantity: quantity,
                    fullfillmentStoreId: fulfillmentStoreId
                });
            }
            setLocalStorage('save_for_later_objs', JSON.stringify(existingSaveForLaterObjs));
        } catch (e) {
            console.error('Error parsing save for later', e);
        }
    } else {
        const existingSaveForLaterObj: ISaveForLaterCollection = {
            saveForLaterProducts: [{ productId: productId, quantity: quantity, fullfillmentStoreId: fulfillmentStoreId }]
        };
        setLocalStorage('save_for_later_objs', JSON.stringify(existingSaveForLaterObj));
    }
};
